

























import { defineClassComponent, useMessenger } from '@/hooks'

export default defineClassComponent<{
  value: boolean
  title?: string
  message: string
  cancelText: string
  confirmText: string
  style2?: boolean
  noCancel?: boolean
}>(
  {
    props: [
      'value',
      'title',
      'message',
      'cancelText',
      'confirmText',
      'style2',
      'noCancel',
    ],
  },
  ({ props, ctx }) =>
    class {
      visible = useMessenger(
        () => props.value,
        visible => ctx.$emit('input', visible),
      )

      handleCancelClick = () => {
        ctx.$emit('cancel')
        this.visible.value = false
      }

      handleConfirmClick = () => {
        ctx.$emit('confirm')
        this.visible.value = false
      }
    },
)
